export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/science_fiction_fantasy.0ec8858.svg";